var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "svg773",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs777"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 11.359295,8.3603091 6.6260223,11.801729 c -0.1671274,0.12004 -0.3739104,0.185272 -0.5869174,0.185272 -0.2130069,0 -0.4197899,-0.06523 -0.5869173,-0.185272 L 0.71896304,8.3603091 C 0.54649936,8.2123592 0.44142377,8.0109537 0.42452514,7.795965 0.40762651,7.580966 0.48013629,7.3680416 0.62770768,7.1993144 0.77527978,7.0305768 0.98716163,6.9183397 1.2214321,6.8847944 1.4557037,6.8512389 1.6952991,6.8988421 1.892803,7.0181599 L 5.092459,9.3411092 V 0.86156966 c 0,-0.22817971 0.099738,-0.44701423 0.2772693,-0.60836155 0.1775316,-0.16134773 0.4183139,-0.25199202 0.6693766,-0.25199202 0.2510627,0 0.4918451,0.09064433 0.6693767,0.25199202 0.1775316,0.16134732 0.2772693,0.38018184 0.2772693,0.60836155 V 9.3411092 L 10.185407,7.0181599 c 0.09532,-0.081778 0.208301,-0.1446779 0.331768,-0.1846948 0.123468,-0.040027 0.254717,-0.056315 0.385492,-0.04782 0.130774,0.00848 0.258143,0.041565 0.374055,0.097126 0.116015,0.055571 0.217992,0.1324262 0.299533,0.2256819 0.08154,0.093266 0.14089,0.20091 0.174332,0.3161094 0.03344,0.1152098 0.04015,0.2354565 0.01971,0.3531434 -0.02044,0.1176869 -0.0675,0.2302337 -0.138206,0.3305287 -0.07081,0.1002848 -0.163701,0.1861192 -0.2728,0.2520743 z",
    fill: "#283856",
    id: "path771",
    style: {
      strokeWidth: 1.03216
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.9af2f28fa9fcbc95d6493490f7fc57ff.svg";
export { ForwardRef as ReactComponent };